import JsonFormatter from './JsonFormatter';
import ColorFormatter from './ColorFormatter';
import MultiSelectFormatter from './MultiSelectFormatter';

export default { JsonFormatter, ColorFormatter, MultiSelectFormatter };


// WEBPACK FOOTER //
// ./src/formatters/index.js